export function getCKEditorConfig() {
  return {
    toolbar: [
      'heading', '|', 'bold', 'italic', 'link', 'bulletList', 'numberedList'
    ],
    link: {addTargetToExternalLinks: true}
  };
}